import { render } from "./Characters.vue?vue&type=template&id=e47e5af4&scoped=true"
import script from "./Characters.vue?vue&type=script&lang=js"
export * from "./Characters.vue?vue&type=script&lang=js"

import "./Characters.vue?vue&type=style&index=0&id=e47e5af4&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e47e5af4"]])

export default __exports__